import { AgentKnowledgePanel } from "../components/AgentKnowledgePanel";
import { useAuth } from "../hooks/useAuth";

export function KnowledgebasePage() {
  const { user } = useAuth();

  return (
    <div className="flex min-h-full flex-col p-4 px-6 pb-10 md:px-16">
      <div className="pt-4 md:pt-6">
        <h2 className="text-2xl font-semibold tracking-tight text-gray-900">
          Knowledgebase
        </h2>
        <p className="mt-1 text-sm text-slate-500">
          Manage indexed sources and refresh schedules.
        </p>
      </div>

      <div className="mt-6">
        <AgentKnowledgePanel
          draft={{ knowledgeBaseIds: [] }}
          mode="manage"
          showHeader={false}
          organizationId={user?.activeOrganizationId}
        />
      </div>
    </div>
  );
}
